<template>
  <header id="site-header" class="relative" role="banner">
    <div
      class="fixed top-0 left-0 w-full bg-[#fafafa] z-50 border-b border-solid border-[#f0f0f0] shadow-lg"
    >
      <div class="flex flex-row items-center justify-end px-2 py-2 w-[100%]">
        <div class="flex items-center gap-3 mr-auto">
          <router-link
            :to="{ name: 'BpHome', params: { locale } }"
            active-class=""
            exact-active-class=""
          >
            <img
              :src="$t('logo.src')"
              class="w-auto h-[50px] object-contain relative"
              active-class=""
              exact-active-class=""
              :alt="$t('logo.alt')"
            />
          </router-link>
        </div>
        <div class="flex items-center mr-16">
          <span id="reciteEnable" class="btn button mra-rm-button">
            <svg
              id="mra-access-icon-svg"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 122.88 122.88"
            >
              <title>Help me with this site</title>
              <path
                d="M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0Zm-.39,74.18L52.1,98.91a4.94,4.94,0,0,1-2.58,2.83A5,5,0,0,1,42.7,95.5l6.24-17.28a26.3,26.3,0,0,0,1.17-4,40.64,40.64,0,0,0,.54-4.18c.24-2.53.41-5.27.54-7.9s.22-5.18.29-7.29c.09-2.63-.62-2.8-2.73-3.3l-.44-.1-18-3.39A5,5,0,0,1,27.08,46a5,5,0,0,1,5.05-7.74l19.34,3.63c.77.07,1.52.16,2.31.25a57.64,57.64,0,0,0,7.18.53A81.13,81.13,0,0,0,69.9,42c.9-.1,1.75-.21,2.6-.29l18.25-3.42A5,5,0,0,1,94.5,39a5,5,0,0,1,1.3,7,5,5,0,0,1-3.21,2.09L75.15,51.37c-.58.13-1.1.22-1.56.29-1.82.31-2.72.47-2.61,3.06.08,1.89.31,4.15.61,6.51.35,2.77.81,5.71,1.29,8.4.31,1.77.6,3.19,1,4.55s.79,2.75,1.39,4.42l6.11,16.9a5,5,0,0,1-6.82,6.24,4.94,4.94,0,0,1-2.58-2.83L63,74.23,62,72.4l-1,1.78Zm.39-53.52a8.83,8.83,0,1,1-6.24,2.59,8.79,8.79,0,0,1,6.24-2.59Zm36.35,4.43a51.42,51.42,0,1,0,15,36.35,51.27,51.27,0,0,0-15-36.35Z"
              />
            </svg>
            <span class="mra-access-text">Help me with this site</span>
          </span>
          <NavigationOverlay />
        </div>
        <LanguageSwitch
          :disabled="!canSwitchLocale"
          class="absolute top-[67px] right-[10px] py-2 rounded-bl-md rounded-br-md md:min-w-[80px]"
        />
      </div>
    </div>
  </header>
</template>

<script>
import NavigationOverlay from "@/components/NavigationOverlay.vue";
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import { a11yFlags } from "@/utils/accessibilityFlags";

export default {
  name: "SiteHeader",
  components: { NavigationOverlay, LanguageSwitch },
  computed: {
    locale() {
      const p = this.$route?.path || "/";
      return p === "/cy" || p.startsWith("/cy/") ? "cy" : "en";
    },
    canSwitchLocale() {
      const locales = this.$route?.meta?.locales;
      return Array.isArray(locales) && locales.length > 1;
    },
  },
  methods: {
    skipToContent() {
      a11yFlags.userSkippedToContent = true; // ✅ Now valid, no ESLint issues

      const el = document.getElementById("main-content");
      if (!el) return;
      el.setAttribute("tabindex", "-1");
      el.focus({ preventScroll: true });
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },
};
</script>

<style scoped></style>
